import { useSeedkitApi } from '@seedkit/core';
import type { ApiCisModuleApiUseCasesCommonModelsUnreadCountResponseViewModelDto } from 'app/api/data-contracts';
import { SIDEBAR_MENU_IDS } from 'app/src/shared/sidebar-unread-badges/menu-ids';

function extractUnreadCount(
  data: ApiCisModuleApiUseCasesCommonModelsUnreadCountResponseViewModelDto | number | undefined,
): number {
  const raw = typeof data === 'number' ? data : data?.unreadCount;
  const count = Number(raw);
  return Number.isFinite(count) && count > 0 ? count : 0;
}

export async function getApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.applicationsGetApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getUserSupportUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.userSupportGetUserSupportUnreadCount();
  return extractUnreadCount(data);
}

export async function getAddressCollectionApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.addressCollectionApplicationsGetAddressCollectionApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getEventApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.eventApplicationsGetEventApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getGoodDeedsApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.goodDeedsApplicationsGetGoodDeedsApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getVolunteerApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.adminVolunteerApplicationsGetVolunteerApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getMeasureApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.measureApplicationsGetMeasureApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getGamificationApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.gamificationApplicationsGetGamificationApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getCooperationApplicationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Admin');
  const { data } = await api.cooperationApplicationGetCooperationApplicationsUnreadCount();
  return extractUnreadCount(data);
}

export async function getSystemNotificationsUnreadCount(): Promise<number> {
  const api = useSeedkitApi('Notifications');
  const { data } = await api.notificationsCountUnread();
  return typeof data === 'number' && data > 0 ? data : 0;
}

export type ApplicationUnreadCountFetcher = () => Promise<number>;

/** Загрузчики непрочитанных по типам заявок (ключ — id пункта меню). */
export const APPLICATION_TYPE_UNREAD_COUNT_FETCHERS: Record<string, ApplicationUnreadCountFetcher> = {
  [ SIDEBAR_MENU_IDS.APPLICATION_TARGET_ASSISTANCE ]: getAddressCollectionApplicationsUnreadCount,
  [ SIDEBAR_MENU_IDS.APPLICATION_EVENTS ]: getEventApplicationsUnreadCount,
  [ SIDEBAR_MENU_IDS.APPLICATION_MUTUAL_AID_BOARD ]: getGoodDeedsApplicationsUnreadCount,
  [ SIDEBAR_MENU_IDS.APPLICATION_BECOME_VOLUNTEER ]: getVolunteerApplicationsUnreadCount,
  [ SIDEBAR_MENU_IDS.APPLICATION_HELP_WITH_TASK ]: getMeasureApplicationsUnreadCount,
  [ SIDEBAR_MENU_IDS.APPLICATION_PRESENTS ]: getGamificationApplicationsUnreadCount,
  [ SIDEBAR_MENU_IDS.APPLICATION_COOPERATION ]: getCooperationApplicationsUnreadCount,
};
